import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Card,
  List,
  Dropdown,
  Menu,
  Modal,
  Button,
  Row,
  Col,
  Divider,
} from 'antd';
import {
  HomeOutlined,
  PhoneOutlined,
  ExclamationCircleOutlined,
  MailOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
  FileTextOutlined,
} from '@ant-design/icons';

const CarHouseItem = ({ carHouse, deleteCarHouse, onEditUser, addCredit }) => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const { confirm } = Modal;
  const showConfirm = () => {
    confirm({
      title: `Do you Want to delete ${carHouse.name}?`,
      icon: <ExclamationCircleOutlined />,
      okType: 'danger',
      maskClosable: 'true',
      onOk() {
        deleteCarHouse(carHouse.id);
      },
      onCancel() {},
    });
  };

  const items = [
    {
      label: t('common.edit'),
      key: 'edit',
      icon: <EditOutlined />,
      onClick: () => {
        onEditUser(carHouse);
      },
    },
    /*{
      label: 'Credits History',
      key: 'credits-history',
      onClick: () => {
        navigate(`${carHouse.id}/credits`);
      },
    },*/
    {
      label: t('subscriptions.subscriptions'),
      key: 'subscriptions',
      icon: <FileTextOutlined />,
      onClick: () => {
        navigate(`${carHouse.id}/subscriptions`);
      },
    },
    {
      type: 'divider',
    },
    {
      label: t('common.delete'),
      key: 'delete',
      danger: true,
      icon: <DeleteOutlined />,
      onClick: () => {
        showConfirm();
      },
    },
  ];

  return (
    <List.Item>
      <Dropdown.Button
        style={{ position: 'absolute', right: '10px', top: '3px', zIndex: '1' }}
        overlay={<Menu mode="vertical" items={items} />}
      ></Dropdown.Button>
      <Card
        style={{
          boxShadow: 'rgb(178 213 198 / 56%) 2px 4px 8px 2px',
          borderRadius: '8px',
        }}
        headStyle={{ borderBottom: 'none', color: 'var(--ant-primary-8)' }}
        title={carHouse.name}
      >
        <p>
          <HomeOutlined
            style={{
              color: 'var(--ant-primary-6)',
              fontSize: '16px',
              marginRight: '10px',
            }}
          />
          {carHouse.address}
        </p>
        <p>
          <PhoneOutlined
            style={{
              color: 'var(--ant-primary-6)',
              fontSize: '16px',
              marginRight: '10px',
            }}
          />
          {carHouse.phone}
        </p>
        <p>
          <MailOutlined
            style={{
              color: 'var(--ant-primary-6)',
              fontSize: '16px',
              marginRight: '10px',
            }}
          />

          {carHouse.supportEmails[0]}
        </p>

        <Row className="mb-20" justify="space-between">
          <Divider />
          <Col>
            <p>
              <span>{t('subscriptions.credits')}: </span>
              {carHouse?.credits}
            </p>
          </Col>
          {Array.isArray(carHouse.subscriptions) &&
            carHouse.subscriptions.some(
              (sub) => sub.status === 'active' && sub.paymentType === 'prepaid'
            ) && (
              <Col>
                <Button
                  block
                  icon={<PlusCircleOutlined />}
                  onClick={() => {
                    addCredit(carHouse);
                  }}
                >
                  {t('subscriptions.addCredit')}
                </Button>
              </Col>
            )}
        </Row>
        <Button
          block
          type="primary"
          onClick={() => {
            navigate(`${carHouse.id}`);
          }}
        >
          {t('common.profile')}
        </Button>
      </Card>
    </List.Item>
  );
};

export default CarHouseItem;
